
import { graphql, gqlRequest } from '@client/shared/graphql';
import { type ResultOf } from 'gql.tada';

export type Group = ResultOf<typeof UpdateGroupMutation>['updateGroup'];

export const UpdateGroupMutation = graphql(`
  mutation UpdateGroup($name: String!) {
    updateGroup(name: $name) {
      id
      name
    }
  }
`);

export async function updateGroup(variables: { name: string }): Promise<Group> {
  const data = await gqlRequest(UpdateGroupMutation, variables);
  return data.updateGroup;
}

export const GroupMembersQuery = graphql(`
  query GroupMembers {
    users {
      id
      name
      email
      roles
      isActive
      pending
    }
  }
`);

export type GroupMember = ResultOf<typeof GroupMembersQuery>['users'][number];

export async function fetchGroupMembers(): Promise<GroupMember[]> {
  const data = await gqlRequest(GroupMembersQuery, {});
  return data.users;
}

export const TransferOwnershipMutation = graphql(`
  mutation TransferGroupOwnership($toUserId: ID!) {
    transferGroupOwnership(toUserId: $toUserId) {
      id
      roles
    }
  }
`);

export async function transferGroupOwnership(variables: { toUserId: string }): Promise<void> {
  await gqlRequest(TransferOwnershipMutation, variables);
}
